export interface SettingsSection {
  id: string;
  label: string;
  group: string;
  permission: string | string[];
}

export const SETTINGS_SECTIONS: SettingsSection[] = [
  { id: 'dials', label: 'Dial Colors', group: 'Watch Catalog', permission: 'VIEW_SETTINGS_DIALS' },
  { id: 'bracelets', label: 'Bracelet Types', group: 'Watch Catalog', permission: 'VIEW_SETTINGS_BRACELETS' },
  { id: 'dial-swaps', label: 'Dial Swap Prices', group: 'Watch Catalog', permission: 'VIEW_SETTINGS_DIAL_SWAPS' },
  { id: 'bracelet-swaps', label: 'Bracelet Swap Prices', group: 'Watch Catalog', permission: 'VIEW_SETTINGS_BRACELET_SWAPS' },
  { id: 'preset-images', label: 'Preset Images', group: 'Watch Catalog', permission: 'VIEW_SETTINGS_PRESET_IMAGES' },
  { id: 'content', label: 'Watch Contents', group: 'Watch Catalog', permission: 'VIEW_SETTINGS_CONTENT' },
  { id: 'link-prices', label: 'Link Prices', group: 'Watch Catalog', permission: 'VIEW_SETTINGS_LINK_PRICES' },
  { id: 'chrono24', label: 'Chrono24', group: 'Listings', permission: ['VIEW_SETTINGS_CHRONO24', 'VIEW_SETTINGS_CHRONO_SCRAPER'] },
  { id: 'permanent-listings', label: 'Permanent Listings', group: 'Listings', permission: 'VIEW_SETTINGS_PRODUCT_CODES' },
  { id: 'nicknames', label: 'Nicknames', group: 'Listings', permission: 'VIEW_SETTINGS_NICKNAMES' },
  { id: 'locations', label: 'Locations', group: 'Operations', permission: 'VIEW_SETTINGS_LOCATIONS' },
  { id: 'watchmakers', label: 'Watchmakers', group: 'Operations', permission: 'VIEW_SETTINGS_WATCHMAKERS' },
  { id: 'todo', label: 'Todo Columns', group: 'Operations', permission: 'VIEW_SETTINGS_TODOS' },
  { id: 'inspection', label: 'Inspection Questions', group: 'Operations', permission: 'VIEW_SETTINGS_INSPECTION' },
  { id: 'inventory-alerts', label: 'Inventory Alerts', group: 'Operations', permission: 'VIEW_SETTINGS_ALERTS' },
  { id: 'order-flags', label: 'Order Flag Rules', group: 'Operations', permission: 'VIEW_SETTINGS_ORDER_FLAGS' },
  { id: 'notifications', label: 'Notifications', group: 'Workspace', permission: 'VIEW_SETTINGS_NOTIFICATIONS' },
  { id: 'sops', label: 'SOPs', group: 'Workspace', permission: 'VIEW_SETTINGS_SOPS' },
  { id: 'permissions', label: 'Permissions', group: 'Workspace', permission: 'VIEW_SETTINGS_PERMISSIONS' },
  { id: 'custom-filters', label: 'Custom Filters', group: 'Workspace', permission: 'VIEW_SETTINGS_CUSTOM_FILTERS' },
  { id: 'sales-types', label: 'Sales Types', group: 'Finance', permission: 'VIEW_SETTINGS_COMMISSIONS' },
  { id: 'commissions', label: 'Commission Rules', group: 'Finance', permission: 'VIEW_SETTINGS_COMMISSION_RULES' },
  { id: 'banks', label: 'Bank Accounts', group: 'Finance', permission: 'VIEW_BANKING' },
];

export const settingsSectionHref = (id: string) => `/settings?section=${id}`;

export const hasAnyPermission = (permission: string | string[], permissions: string[]) => {
  const required = Array.isArray(permission) ? permission : [permission];
  return required.some((key) => permissions.includes(key));
};
